<template>
  <div class="member-stove">
    <div class="member-stove-header">
      <div class="member-stove-header-title">我的小灶答疑</div>
      <CourseFilter @on-search="onSearch" />
    </div>
    <div class="member-stove-course-list" v-loading="loading">
      <div class="member-stove-course-item" v-for="item in list" :key="item.date" ref="list">
        <div class="member-stove-course-item-header">
          <span class="member-stove-course-item-date">{{ item.date }}</span>
          <span class="member-stove-course-item-week">{{ item.week }}</span>
        </div>
        <div class="member-stove-course-item-period-list">
          <div
            v-for="period in item.periods"
            :key="period.period_id"
            class="member-stove-course-item-period"
            :data-id="period.period_id"
          >
            <div class="left">
              <div class="left-name">
                <span class="left-name-subject" v-if="period.subject_name">{{
                  period.subject_name
                }}</span>
                <span>{{ period.period_name }}</span>
              </div>
              <div class="left-time">
                <span class="left-time-round">{{ period.hour_start }} - {{ period.hour_end }}</span>
                <template v-if="period.live_state == 1">
                  <img
                    src="@/assets/images/course/time_line.png"
                    style="width: 16px; height: 16px; margin-right: 4px"
                  />
                  <span style="color: #3c3a43; font-size: 12px">待上课</span>
                </template>
                <template v-else-if="period.live_state == 2">
                  <div class="live-animation">
                    <span class="live-bar"></span>
                    <span class="live-bar"></span>
                    <span class="live-bar"></span>
                  </div>
                  <span style="color: #ff2020; font-size: 12px">上课中</span>
                </template>
                <template v-else-if="period.live_state == 3">
                  <img
                    src="@/assets/images/course/correct_line.png"
                    style="width: 16px; height: 16px; margin-right: 4px"
                  />
                  <span style="color: #8c8b97; font-size: 12px">已下课</span>
                </template>
              </div>
              <div class="left-teacher">
                <img
                  src="https://cdn.yuaiweiwu.com/fe/imgs/740b1680-000b-11f1-bf53-d59e0d9b758f-default-teacher.png"
                  alt=""
                  style="width: 16px; height: 16px; margin-right: 8px"
                />
                {{ period.teacher_name }}
              </div>
            </div>
            <div class="right">
              <span
                v-if="period.live_state == 1"
                class="period-not-started"
                @click.stop="goToPlay(period)"
              >
                待开课
              </span>
              <span
                v-else-if="period.live_state == 2"
                class="living"
                @click.stop="goToPlay(period)"
              >
                去学习
              </span>
              <template v-else>
                <span v-if="period.live_state == 3" @click.stop="goToPlay(period)"> 看回放 </span>
                <span class="period-not-started" v-else :style="{ cursor: 'not-allowed' }">
                  看回放
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        v-if="total > pageParams.page_size"
        class="pagination-wrapper"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageParams.page_size"
        :current-page="pageParams.page_num"
        @current-change="onPageChange"
      ></el-pagination>
      <div class="no-data" v-if="list.length === 0 && !loading">
        <div class="no-data-content">
          <img
            src="https://cdn.yuaiweiwu.com/fe/imgs/28d24860-0041-11f1-b847-65251ba19b37-%E7%BC%BA%E7%9C%81%E9%A1%B5%201.png"
            alt=""
          />
          <span class="no-data-text">暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { triggerLoaded } from '@/components/LoadContainer.vue';
import CourseFilter from './CourseFilter.vue';
export default {
  name: 'MemberStoveCourse',
  components: {
    CourseFilter,
  },
  data() {
    return {
      list: [],
      pageParams: {
        page_num: 0,
        page_size: 10,
      },
      total: 1,
      loading: false,
    };
  },
  created() {
    triggerLoaded(this);
    this.fetchList();
  },
  methods: {
    onPageChange(page) {
      this.pageParams.page_num = page;
      this.fetchList();
    },
    onSearch(params) {
      this.pageParams.page_num = 1;
      this.fetchList(params);
    },
    fetchList(
      filterParams = {
        subject: 0,
        time: 0,
        status: 0,
      },
    ) {
      this.loading = true;
      this.$http
        .get('/backend-api/app/study/stove/periods', {
          ...filterParams,
          ...this.pageParams,
        })
        .then((data) => {
          this.list = data.chapters;
          this.total = data.total;
          // 第一次请求的时候不传pageNum并且定位到锚点，后续请求不关注
          if (data.anchor_id && !this.pageParams.page_num) {
            this.$nextTick(() => {
              const dom = document.querySelector(`[data-id="${data.anchor_id}"]`);
              if (dom && dom.scrollIntoView) {
                dom.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            });
          }
          this.pageParams.page_num = data.page_num;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goToPlay(period) {
      this.$livePlay(period.course_id, 102, {
        id: period.chapter_id,
        period_id: period.period_id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.member-stove {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.member-stove-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  background-color: #fff;
  border-radius: 8px;
  height: 56px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.member-stove-header-title {
  color: #000;
  font-size: 16px;
  font-weight: 500;
}
.member-stove-course-list {
  height: 0;
  flex: 1;
  max-height: 600px;
  overflow-y: auto;
  background-color: #fff;
  padding: 24px 32px;
  border-radius: 8px;
  .member-stove-course-item {
    margin-bottom: 24px;
    .member-stove-course-item-header {
      vertical-align: text-bottom;
      margin-bottom: 16px;
      .member-stove-course-item-date {
        font-size: 18px;
        font-weight: 500;
        color: #08021e;
        margin-right: 8px;
      }
      .member-stove-course-item-week {
        font-size: 14px;
        color: #86909c;
      }
    }
  }
  .pagination-wrapper {
    margin-bottom: 0;
    margin-top: 0;
  }
  .member-stove-course-item-period-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .member-stove-course-item-period {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px 16px 16px;
      background: #fafafa;
      border-radius: 8px;
      .left {
        .left-name {
          color: #1a1a1a;
          font-size: 16px;
          font-weight: 500;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .left-name-subject {
            margin-right: 8px;
            color: #f4272f;
            border-radius: 4px;
            font-size: 12px;
            border: 0.5px solid #f4272f;
            display: inline-block;
            padding: 2px 4px;
          }
        }
        .left-time {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .left-time-round {
            font-size: 14px;
            color: #666;
            margin-right: 16px;
          }
          .live-animation {
            display: flex;
            align-items: center;
            gap: 3px;
            width: 16px;
            height: 16px;
            margin-right: 4px;
            .live-bar {
              width: 1px;
              background-color: #ff2020;
              border-radius: 2px;
              animation: live-pulse 1s ease-in-out infinite;
              &:nth-child(1) {
                height: 6px;
                animation-delay: 0s;
              }
              &:nth-child(2) {
                height: 10px;
                animation-delay: 0.2s;
              }
              &:nth-child(3) {
                height: 6px;
                animation-delay: 0.4s;
              }
            }
          }
        }
        .left-teacher {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #666;
        }
      }
      .right {
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 104px;
          height: 40px;
          cursor: pointer;
          border-radius: 30px;
          background-color: #ffefef;
          color: #ff2020;

          &.period-not-started {
            background-color: #f1f5ff;
            color: #a6a6b1;
          }

          &.living {
            background-color: #ff2020;
            color: #fff;
          }
        }
      }
    }
  }
  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .no-data-content {
      position: relative;
      width: 196px;
      height: 152px;
      img {
        width: 100%;
        height: 100%;
      }
      .no-data-text {
        position: absolute;
        bottom: 13px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 16px;
        color: #1d1b20;
      }
    }
  }
}

@keyframes live-pulse {
  0%,
  100% {
    transform: scaleY(0.6);
  }
  50% {
    transform: scaleY(1);
  }
}
</style>
